import React, { createRef, RefObject, Suspense, useEffect, useState } from "react";
import ct from "class-types.macro";
import ReactDOM from "react-dom";
import connectUserAndChat, { User } from "~/common/Store/connectUserAndChat";
import Modal, { Header, Footer } from "~/common/ModalReact";
import Button from "~/common/Buttons";
import ProductCutDownForm from "./ProductCutDownForm";
import { ProductCutDown, ProductDetailGroupingSelect } from "../ProductDetailPageResult";
import useIsMounted from "~/common/useIsMounted";
import VideoPlayer from "~/common/MediaViewerV2/SharedComponents/VideoViewer/VideoWrapper/VideoPlayer";
import VirtualGrouping from "../VirtualGrouping/index";
import sendVideoPlayEvent from "~/common/MediaViewerV2/sendVideoPlayEvent";
import(/* webpackChunkName: "modals-standalone" */"~/bootstrap/less/modals-standalone.less");
interface Props {
  productCutDown: ProductCutDown;
  productName: string;
  productItemNumber: string;
  productPrice: number;
  isVirtual: boolean;
  isVirtualGroupMaster: boolean;
  productDetailGroupingSelect: ProductDetailGroupingSelect[];
  handleVirtualGroupingSelectChange: (itemNumber: string) => string;
  selectedItemNumber: string;
  hasQuantityDiscounts: boolean;
  quantityDiscountPrice?: number;
  quantityDiscountQty?: number;
  user: User;
}
const ProductCutDownModal = ({
  productCutDown,
  productName,
  productItemNumber,
  productPrice,
  isVirtual,
  isVirtualGroupMaster,
  productDetailGroupingSelect,
  selectedItemNumber,
  handleVirtualGroupingSelectChange,
  hasQuantityDiscounts,
  quantityDiscountPrice,
  quantityDiscountQty,
  user
}: Props) => {
  const isMounted = useIsMounted();
  const form = createRef<HTMLFormElement>();
  const [openModal, setOpenModal] = useState(false);
  const [activePlayer, setActivePlayer] = useState(false);
  const [displayCutDownCartError, setDisplayCutDownCartError] = useState(false);
  const submitForm = (form: RefObject<HTMLFormElement>) => {
    if (isVirtualGroupMaster) {
      setDisplayCutDownCartError(true);
      return;
    }
    if (form.current !== null) {
      form.current.submit();
      setDisplayCutDownCartError(false);
    }
  };
  useEffect(() => {
    const openTableCutDownButton = document.querySelector("[data-component=TableCutDown]");
    if (openTableCutDownButton) {
      openTableCutDownButton.addEventListener("click", () => {
        setOpenModal(true);
      });
    }
    setDisplayCutDownCartError(false);
  }, [isVirtualGroupMaster]);
  return <>
      {isMounted && ReactDOM.createPortal(<Suspense fallback={null}>
            <Modal isOpen={openModal} onRequestClose={() => {
        setOpenModal(false);
      }} className={`${ct("md:max-w-screen-md")}`}>
              <Header closeModal={() => {
          setOpenModal(false);
        }}>
                <h3 className={`${ct("flex", "text-base", "m-0", "md:text-xl")}`}>
                  Stainless Steel Cut Down
                </h3>
              </Header>
              <main className={`${ct("flex-1", "m-0")}`}>
                <div className="row">
                  <div className="cols-sm--5">
                    <div className="cutdown__column">
                      <p style={{
                  fontSize: "15px",
                  lineHeight: "1.4em"
                }}>
                        Cut down tables are made-to-order and cannot be canceled
                        or returned once your order is placed. Please contact
                        Customer Solutions prior to placing your order if you
                        have any questions or concerns.
                      </p>
                      <div>
                        <VideoPlayer posterImage={productCutDown.cutDownVideo.poster} sources={productCutDown.cutDownVideo.sources} activePlayer={activePlayer} setActivePlayer={setActivePlayer} currentIndex={0} selected={0} isSmallVideoPlayer handleGtmVideoPlayEvent={sendVideoPlayEvent} />
                      </div>
                    </div>
                  </div>
                  <div className="cols-sm--7">
                    <div className="cutdown__column cutdown__column--bordered">
                      <div className="cutdown__info">
                        <h3 className="cutdown__info__name">{productName}</h3>
                        <p className="cutdown__info__number" style={{
                    fontSize: "15px",
                    lineHeight: "1.4em"
                  }}>
                          #{productItemNumber.toLocaleUpperCase()}
                        </p>
                      </div>
                      {isVirtual && <div style={{
                  marginBottom: "14px"
                }}>
                          <VirtualGrouping productGroupingSelect={productDetailGroupingSelect} handleVirtualGroupingSelectChange={handleVirtualGroupingSelectChange} virtualGroupMemberToDisplay={selectedItemNumber} user={user} showPricingInDropdown={false} />
                        </div>}
                      {displayCutDownCartError && <div className="add-to-cart" style={{
                  fontSize: "14px",
                  marginBottom: "10px",
                  marginTop: "-18px"
                }}>
                          <p className="messages">
                            Please select{" "}
                            {productDetailGroupingSelect.length > 1 ? "options" : "an option"}{" "}
                            for this product.
                          </p>
                        </div>}
                      <ProductCutDownForm productCutDown={productCutDown} productItemNumber={productItemNumber} productPrice={productPrice} form={form} hasQuantityDiscounts={hasQuantityDiscounts} quantityDiscountPrice={quantityDiscountPrice} quantityDiscountQty={quantityDiscountQty} />
                    </div>
                  </div>
                </div>
              </main>
              <Footer>
                <Button color="red" aria-label="Submit Feedback" data-testid="cut-down-modal-atc" type="submit" onClick={() => submitForm(form)}>
                  Add to Cart
                </Button>
                <Button className={`${ct("ml-3")}`} color="light" aria-label="Cancel" type="button" onClick={() => setOpenModal(false)}>
                  Close
                </Button>
              </Footer>
            </Modal>
          </Suspense>,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    document.querySelector("body") as Element)}
    </>;
};
export default connectUserAndChat(ProductCutDownModal);